import { stripCinemaSlug } from "./cinemaSlugs"

/** Поисковые роботы, которым показываем публичные страницы без выбора города. */
const SEARCH_BOT_RE =
    /googlebot|google-inspectiontool|googleother|yandex(?:bot|images|video|media|news|renderresourcesbot|additionalbot)|bingbot|bingpreview|mail\.ru_bot|duckduckbot|baiduspider|applebot|facebookexternalhit|twitterbot/i

let cached: boolean | undefined

export function isSearchBot(userAgent?: string): boolean {
    const ua = userAgent ?? (typeof navigator !== "undefined" ? navigator.userAgent : "")
    if (userAgent == null && cached !== undefined) return cached
    const result = Boolean(ua) && SEARCH_BOT_RE.test(ua)
    if (userAgent == null) cached = result
    return result
}

/** Афиша, карточка фильма и контакты — то, что роботу нужно проиндексировать. */
export function isCrawlablePublicPath(pathname: string): boolean {
    const rest = stripCinemaSlug(pathname)
    return (
        rest === "/afisha" ||
        rest === "/contacts" ||
        rest === "/home" ||
        /^\/afisha\/film\/\d+$/.test(rest) ||
        /^\/promo\/[^/]+$/.test(rest)
    )
}
